import React, { Component } from "react";
import FixedView from "../FixedView";
import { nanoid } from "nanoid";
import { FormBuilderObjects, InputTypeToType, TypeToInputType } from "../../variables/formBuilderData";
import inputComponents from "./inputComponents";
import { checkTranslation, paramToStandardOption, translate } from "../../utils/useful";
import StagesManager from "../StagesManager";
import EmptyInput from "./EmptyInput";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../stores/actionsList';
import { EntitiesData } from "../../variables/EntitiesData";


class ParamsListItems extends React.Component {
    state = {
        items: [],
        data: {
            root: {
                id: 'root',
                action: 'and',
                conditions: {}
            }
        },

        slectedCell: [],
        search: "",
        sourceItems: [],
        sourceType: [],

        currentPath: [],
        currentList: []
    }


    componentDidMount() {
        // let current = { level: 0, groupId: 'root', parents: [] }

        // if (this.props.data) {
        //     this.setState({ data: this.props.data })
        // } else {
        //     this.setState({ current }, () => {
        //         // this.doAdd('con', current)
        //     })
        // }
        // let items = this.props.items ?? this.props.optionsList
        // this.setState({ items: items }, () => {
        //     // this.setState({ sourceItems: this.state.items, source: this.props.prop?.source, target: this.props.prop?.target, operator: this.props.prop?.operator })
        // });
        // this.init()
        this.createCurrentList()
        this.splitData()

    }


    componentDidUpdate(prevProps) {

        if ((prevProps.params != this.props.params)) {
            this.createCurrentList()
        };

        if (prevProps.data != this.props.data) {
            this.splitData()
        }
        // if ((prevProps.items != this.props.items) || (prevProps.optionsList != this.props.optionsList)) {
        //     this.init()
        // };
    }

    splitData = () => {

        let params = this.props.params

        let data = this.props.data


        if (this.props.variableIndicatior) {
            if (this.props.variableIndicatior == '{{') {

                if (/\{\{(.*?)\}\}/.test(data)) {
                    data = data.replace('{{', '').replace('}}', '')
                }

            }
        }

        let [currentData, path] = paramToStandardOption(params, data, "{{")

        this.setState({ currentDataPath: path, currentData: currentData })

    }

    createCurrentList = (setValue) => {

        // console.log("createCurrentList",setValue)

        let params = this.props.params
        let paramsList = params
        if (params && typeof paramsList == 'object') {
            paramsList = Object.values(params)
        }

        this.getListFromArray(paramsList, 0, (currentList, currentItem, currentIndex) => {

            // console.log(this.state.currentPath)



            let finalList = []
            let validTypes = this.props.validTypes
            // console.log(validTypes)

            if (currentList) {
                for (let i = 0; i < currentList.length; i++) {
                    const item = currentList[i];
                    let valid = true
                    let extendable = false
                    // if (Array.isArray(validTypes)) {

                    this.analysisValidTypes(item, (myValid, myExtendable) => {

                        // console.log(myValid, myExtendable, item)
                        valid = myValid
                        extendable = myExtendable
                    })

                    // }

                    if (valid || extendable) {
                        finalList.push({ valid, extendable, item })
                    }
                }
            }

            // finalList.sort((a, b) => { return (a === b) ? 0 : a ? 1 : -1 })

            // console.log(currentList)

            // if (setValue && (!finalList || finalList.length == 0)) {
            if (setValue || (!finalList || finalList.length == 0)) {

                // console.log(this.state.currentPath)
                let currentPath = this.state.currentPath
                let final
                if (currentPath.length > 1) {
                    final = currentPath.join('.')
                } else {
                    final = currentPath[0]
                }

                if (this.props.variableIndicatior) {
                    if (this.props.variableIndicatior == '{{') {
                        final = '{{' + final + '}}'
                    }
                }
                this.props.changeValue(this.props.header?.key, final, this.props.extra)

            }


            this.setState({ currentList: [] }, () => {
                this.setState({ currentList: finalList, currentItem, currentIndex }, () => {
                    if (this.mainList) {
                        this.mainList.scrollTo(0, 0)
                    }
                })
            })

        })


    }

    analysisValidTypes = (item, cb) => {

        let validTypes = this.props.validTypes



        let type = (item.dataType ?? item.type)?.toLowerCase()
        let dataType = (InputTypeToType[(item.dataType ?? item.type)] ?? type) ?? 'object'

        if (dataType == 'field' && Array.isArray(item.fieldTypes) && item.fieldTypes.length == 1) {
            dataType = item.fieldTypes[0]
        }

        // console.log(dataType)

        let valid = validTypes ? validTypes.includes(dataType) : true


        let extendable = false



        if (EntitiesData[dataType] || dataType == "record" || dataType == "object" || dataType == "permission") {

            let list = this.getListFromItem(item, dataType)


            if (!Array.isArray(list) || list.length == 0) {
                cb(valid, extendable)
                return
            } else {

                // console.log("list", list)

                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    this.analysisValidTypes(element, (myValid, myExtendable) => {
                        if (myValid || myExtendable) {
                            extendable = true
                        }
                    })
                }
            }
        }

        // console.log(dataType, item, valid, extendable)


        cb(valid, extendable)

    }



    getListFromArray = (array, index, cb) => {

        let myKey = this.state.currentPath[index]
        let list

        // console.log("myKey", myKey)


        if (myKey) {
            for (let i = 0; i < array.length; i++) {
                const element = array[i];
                if (element.key == myKey || element._id == myKey) {

                    let dataType = InputTypeToType[(element.dataType ?? element.type)] ?? (element.dataType ?? element.type)

                    let list = this.getListFromItem(element, dataType)

                    if (!list) {
                        cb(list, null, (index + 1))
                        return
                    }

                    if (index == this.state.currentPath.length - 1) {
                        cb(list, element, (index + 1))
                    } else {
                        this.getListFromArray(list, (index + 1), cb)
                    }
                }
            }
        } else {
            list = array
            cb(list, null, index)
        }


    }


    getListFromItem = (item, dataType) => {

        let list
        if (item.structure) {
            list = item.structure
        }

        if (item.list) {
            list = item.list
        }

        if (!list) {


            if (dataType == 'field' && Array.isArray(item.fieldTypes) && item.fieldTypes.length == 1) {
                dataType = item.fieldTypes[0]
            }
            let entity = EntitiesData[dataType]
            // console.log(dataType, entity,item.permissions)

            if (entity) {
                list = Object.values(entity)

                // console.log(list)
                // console.log(index, this.state.currentPath.length - 1)
                // this.getListFromArray(list, (index + 1), cb)

            } else if (item.permissions) {
                list = Object.values(item.permissions)
            }

        }

        return list

    }



    init() {
        // console.log("INIT",this.props.items)
        let items = this.props.items ?? this.props.optionsList
        this.setState({ items: items }, () => {
            this.setState({ sourceItems: this.state.items, source: this.props.prop?.source, target: this.props.prop?.target, operator: this.props.prop?.operator })
        })
        let element
        if (typeof items == 'object') {
            for (let i = 0; i < Object.values(items).length; i++) {
                element = Object.values(items)[i];
                this.setState({ slectedCell: element }, () => {
                })
            }
        }
        else {

            for (let i = 0; i < items?.length; i++) {
                element = items[i];


                this.setState({ slectedCell: element }, () => {
                })
            }
        }
    }







    itemSelected = (item, baseKey) => {

        // console.log("itemSelected")

        let params = this.props.params
        let currentPath = this.state.currentPath ?? []
        let key = typeof baseKey == 'object' ? (baseKey._id ?? baseKey.key) : baseKey

        if ((item?.type == "field" || item?.type == "FieldInput") && (!Array.isArray(item.fieldTypes) || item.fieldTypes.length != 1)) {

            this.props.actions.addNotif({ type: 'error', title: '{{lang}}Type error', description: "{{lang}}This type of field can have more than one data type, so it can not be used for logical condition. Use another variable or limit this field to only one data type." })
            return

        }

        currentPath.push(key)


        this.setState({ source: key, operator: "", currentPath: currentPath }, () => {
            // if (this.props.headers || check) {

            this.createCurrentList(true)


            // if (!this.props.optionsList || check) {

            //     let data = this.props.data
            //     // data.conditions[id].source = key
            //     // data.conditions[id].operator = null

            //     // let current = { groupId: this.props.data.id, id: this.props.prop?.id, key: 'source', parents: this.props.parents, extra: { sourceType: this.state.sourceType } }
            //     // new Promise((resolve) => {
            //     //     if (this.props.setCurrent) {
            //     //         this.props.setCurrent('current', current, () => {
            //     //             resolve()
            //     //         })
            //     //     }
            //     //     else {
            //     //         resolve()
            //     //     }
            //     // }).then(() => {

            //     //     if (this.props?.changeInputValue) {
            //     //         this.props.changeInputValue("source", key, current, this.props.extra)

            //     //         let type = ''
            //     //         // TO DO: Check the logic
            //     //         if (['diagramVariables', 'sharedVariables'].includes(current.extra.sourceType[0])) {
            //     //             type = current.extra.sourceType[0]
            //     //         } else {
            //     //             type = 'collection'
            //     //         }
            //     //         const newCurrent = { ...current }
            //     //         newCurrent.key = 'type'
            //     //         this.props.changeInputValue("type", type, newCurrent, this.props.extra)


            //     //     }
            //     //     // this.firstView.hideView()
            //     //     // this.thirdView.showView();
            //     // })


            // }

        })


    }




    searchInput = (e) => {
        this.setState({ search: e.target.value }, () => {
            this.filterHandler(e);
        })
    }


    filterHandler = () => {
        let temp = [];

        if (Array.isArray(this.state.items)) {
            let items = [...this.state.items];
            for (let i = 0; i < items.length; i++) {
                let content = items[i];
                if (content?.information?.label.toLowerCase().includes(this.state.search.toLowerCase())) {
                    temp.push(content);
                }
            }


        }
        else {
            let items = { ...this.state.items };
            for (let i = 0; i < Object.values(items)?.length; i++) {
                let content = Object.values(items)[i];
                if (content?.label.toLowerCase().includes(this.state.search.toLowerCase())) {
                    temp.push(content);
                }
            }

        }
        this.setState({ sourceItems: temp }, () => {
        });
    };




    setSourceAsObject = (item) => {

        let sourceType = this.state.sourceType
        let key = item.key

        sourceType.push(key)


        this.setState({ tempCurrentSourceObject: item, sourceType }, () => {
            this.stagesManager.changeStage('object')
        })
    }

    goToPreviousStage = () => {

        let currentPath = this.state.currentPath

        if (currentPath.length == 0) {
            this.props.goToMain()
        } else {

            currentPath.pop()
            this.setState({ currentPath }, () => {
                this.createCurrentList()
            })
        }

    }


    expandItem = (e, item, baseKey) => {
        e.stopPropagation();
        // console.log(item)

        // console.log("expandItem")


        let currentPath = this.state.currentPath ?? []
        let key = typeof baseKey == 'object' ? (item._id ?? item.key) : baseKey


        currentPath.push(key)


        this.setState({ currentPath: currentPath }, () => {

            // console.log(currentPath)
            this.createCurrentList()

        })

    }





    render() {
        // let sourceLabel
        // let sourceType
        // let sourceHelperObject

        // let sourceTypeItems
        // let sourceIcon
        // let selectedField

        // if (this.props.prop?.source) {
        //     if (Array.isArray(this.props.params)) {

        //         this.props.params?.forEach((item) => {
        //             if (item.key == this.props.prop?.source) {
        //                 selectedField = JSON.parse(JSON.stringify(item))
        //                 selectedField.information.placeholder = '{{lang}}Value ...'
        //                 sourceLabel = item.information.label
        //                 sourceType = item.type
        //                 // console.log("sourceType",sourceType)
        //                 if (!FormBuilderObjects[sourceType]) {
        //                     sourceType = TypeToInputType[sourceType]
        //                 }
        //                 sourceTypeItems = FormBuilderObjects[sourceType]?.operators
        //                 sourceIcon = FormBuilderObjects[sourceType]?.icon
        //             }
        //         })
        //     }
        //     else {
        //         if (this.props.params && typeof this.props.params == 'object') {
        //             Object.values(this.props.params)?.forEach((item) => {
        //                 if (item.list) {

        //                     item.list.map((element) => {
        //                         if (element.key == this.props.prop?.source || element.name == this.props.prop?.source || element._id == this.props.prop?.source) {
        //                             sourceLabel = element.name ?? element?.information?.label
        //                             sourceType = element.field ?? element.type

        //                             if (Array.isArray(element.fieldTypes) && element.fieldTypes.length == 1) {
        //                                 sourceType = TypeToInputType[element.fieldTypes[0]]
        //                             }

        //                             selectedField = JSON.parse(JSON.stringify(element))

        //                             if (!selectedField.information) {
        //                                 selectedField.information = {}
        //                             }
        //                             selectedField.information.placeholder = '{{lang}}Value ...'

        //                             if (!FormBuilderObjects[sourceType]) {
        //                                 sourceType = TypeToInputType[sourceType]
        //                             }
        //                             sourceTypeItems = FormBuilderObjects[sourceType]?.operators
        //                             sourceIcon = FormBuilderObjects[sourceType]?.icon

        //                             // console.log("TP2",element)
        //                         }

        //                         if (!sourceType && this.props.prop?.source.includes('.')) {


        //                             let splitedKey = this.props.prop?.source.split('.')
        //                             // console.log("splitedKey",splitedKey)
        //                             if (element.key == splitedKey[0] && Array.isArray(element.structure)) {

        //                                 splitedKey.splice(0, 1)
        //                                 let fieldKey = splitedKey.join('.')

        //                                 for (let m = 0; m < element.structure.length; m++) {
        //                                     const field = element.structure[m];
        //                                     // console.log("HERE!",fieldKey,field)

        //                                     if (field.key == fieldKey) {

        //                                         sourceLabel = field.name ?? field?.information?.label
        //                                         sourceType = field.field ?? field.type
        //                                         selectedField = JSON.parse(JSON.stringify(field))
        //                                         if (!selectedField.information) {
        //                                             selectedField.information = {}
        //                                         }
        //                                         selectedField.information.placeholder = '{{lang}}Value ...'
        //                                         selectedField.information.disabled = false

        //                                         // console.log("HERE!!",selectedField)
        //                                         if (element.dynamicStructureFrames) {
        //                                             selectedField.dynamicStructureFrames = element.dynamicStructureFrames
        //                                         }

        //                                         if (!FormBuilderObjects[sourceType]) {
        //                                             sourceType = TypeToInputType[sourceType]
        //                                         }

        //                                         sourceTypeItems = FormBuilderObjects[sourceType]?.operators
        //                                         sourceIcon = FormBuilderObjects[sourceType]?.icon

        //                                         sourceHelperObject = element
        //                                     }
        //                                 }

        //                             }
        //                         }
        //                     })
        //                 } else {

        //                     if (item.key == this.props.prop?.source) {
        //                         sourceLabel = item.label

        //                     }
        //                 }
        //             })
        //         }

        //     }
        // }


        let currentItem = this.state.currentItem
        // let validTypes = ['object', 'record', ...this.props.validTypes]

        return (
            <div>

                <StagesManager height={'100%'} ref={e => this.stagesManager = e} fast={true}>
                    <div stage={0} ref={el => this.mainList = el} stageName='main' className="h-100 scroll-no-scrollbar " style={{ minHeight: 35, maxHeight: 200 }}>

                        <div className="bb-gray w-100 px-2 py-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                            {this.props?.hasPreviousPage || this.state.currentItem && (
                                <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                    <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '18px' }} alt="" />
                                </button>
                            )}
                            {this.state.currentItem ? (
                                <p className="text-small text-bold">{(translate(((currentItem.label ?? currentItem.title) ?? (currentItem.name ?? currentItem?.information?.label))))}</p>
                            ) : (
                                <p className="text-small text-bold">{(translate("Variables"))}</p>
                            )}
                        </div>

                        {/* <div className="fields-search flexc p-1 w-100 top-0 " style={{ zIndex: 1, background: "#fff", borderBottom: '1px solid #eee', overflow: 'hidden', position: 'sticky', borderTopRightRadius: 7, borderTopLeftRadius: 7 }}>
                            <img src="/assets/icons/gantt/search.svg" className="mld-1" />
                            <input type="search" name="name" className="fields-search text-smaller p-1 w-100 text-semibold " style={{ borderBottom: 'none', }} placeholder={translate("Search ...")} value={this.state.search} onChange={(e) => this.searchInput(e)} />
                        </div> */}



                        <div className="pb-1 pt-1 w-100 h-100" style={{ flex: 1, borderRadius: 4, position: 'relative', }}>
                            {/* {Array.isArray(this.props.params) ? (
                                <>
                                    {
                                        this.props.params?.map((item, index) => {

                                            return (
                                                <div key={index} className="flexc p-1 px-2 mb-1 grayscale-filter action w-100" style={{ cursor: "pointer" }} onClick={() => this.itemSelected(item, item, this.props.prop?.id, null, true)}>
                                                    <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                        <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[item.type]?.icon} width="18px" />
                                                    </div>
                                                    <p className="text-small text-semibold">{checkTranslation(item?.information?.label)}</p>
                                                </div>
                                            )
                                        })
                                    }
                                </>
                            ) : ( */}
                            <div className="w-100 d-flex flex-column">

                                {Array.isArray(this.state.currentList) && this.state.currentList?.map((option, index) => {
                                    let item = option.item
                                    let label = (item.label ?? item.title) ?? (item.name ?? item?.information?.label)
                                    let key = item._id ?? item.key
                                    let type = (item.dataType ?? item.type)?.toLowerCase()
                                    let dataType = InputTypeToType[(item.dataType ?? item.type)] ?? type

                                    let isObject = false
                                    let isValid = option.valid
                                    let canExpand = false
                                    let currentDataPath = this.state.currentDataPath
                                    if (currentDataPath) {
                                        currentDataPath = this.state.currentDataPath[this.state.currentIndex]
                                    }
                                    let isSelected = (key == (currentDataPath?._id ?? currentDataPath?.key))

                                    // console.log(isSelected,this.state.currentIndex, key, currentDataPath)

                                    if (type == 'field' || type == 'FieldInput') {
                                        if (Array.isArray(item.fieldTypes) && item.fieldTypes.length == 1) {
                                            type = item.fieldTypes[0]
                                        }
                                    }

                                    if (type) {
                                        type = TypeToInputType[type] ?? (item.dataType ?? item.type)
                                    }
                                    // if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput' || item.list || item.structure) {
                                    //     isObject = true
                                    // }

                                    // if (validTypes) {

                                    //     if (dataType && !validTypes.includes((dataType))) {
                                    //         isValid = false
                                    //     }
                                    // }

                                    // if (dataType && dataType != 'object' && dataType != 'record') {
                                    canExpand = option.extendable
                                    // }

                                    if ((dataType == 'object' || dataType == 'record' || !dataType)) {
                                        isObject = true
                                    }
                                    // console.log(dataType, isObject)

                                    // console.log(dataType)
                                    // if (['user', 'stage', 'frame', 'applet'].includes(dataType)) {
                                    //     canExpand = true
                                    // }
                                    // if (item.permissions) {
                                    //     canExpand = true
                                    // }


                                    // console.log(isValid, canExpand, option)


                                    if (isValid || true)
                                        return (
                                            <button key={key} className={"py-2 px-2 my-1 w-100 text-start hover-fields"} onClick={(e) => { if (isValid && !isObject) { this.itemSelected(item, key) } else { this.expandItem(e, item, key) } }} style={{ backgroundColor: isSelected ? '#007aff20' : '' }}>
                                                <div className="flexcb " >

                                                    <div className="flexc">
                                                        {(type && FormBuilderObjects[type]) ? (
                                                            <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                                <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" alt="" />
                                                            </div>
                                                        ) : (
                                                            < div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                                <img className="mx-1" style={{ opacity: 0.8 }} src={'/assets/icons/useful/brackets-curly.svg'} width="12px" alt="" />
                                                            </div>
                                                        )}


                                                        <div className="">
                                                            <p className="text-small text-semibold">{checkTranslation(label)}</p>


                                                            {/* {item.list && (
                                                                <p className="text-smaller color-gray-2 ">{item.list?.length} items</p>
                                                            )}
                                                            {item.structure && (
                                                                <p className="text-smaller color-gray-2 ">{item.structure?.length} items</p>
                                                            )} */}

                                                            {(canExpand && !isObject) && (
                                                                <button className="flexc" onClick={(e) => { this.expandItem(e, item, key) }}>
                                                                    <p className="text-smaller text-link ">{translate("Expand")}</p>
                                                                </button>
                                                            )}

                                                        </div>


                                                    </div>

                                                    {isObject && (
                                                        <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                                    )}
                                                </div>


                                            </button>
                                        )
                                })
                                }


                            </div>
                            {/* )} */}
                        </div>
                    </div>

                    {/* <div stage={1} stageName='second' className="mt-2" style={{ minHeight: '100px' }}>
                        {this.props.params && this.props.params[this.state.source]?.list?.length != 0 ? (
                            <div className="scroll-no-scrollbar" style={{ maxHeight: '200px' }}>
                                <div className="bb-gray w-100 px-2 py-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                                    <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                        <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} alt="" />
                                    </button>
                                    <p className="text-small text-semibold">{(checkTranslation(this.props.params[this.state.source]?.label))}</p>
                                </div>
                                <div className="pt-1">
                                    {this.props.params && this.props.params[this.state.source]?.list?.map((element) => {
                                        let name = element.name ?? element?.information?.label
                                        let key = element._id ?? element.key
                                        let type = (element.dataType ?? element.type)?.toLowerCase()
                                        let isObject = false


                                        if (type == 'field' || type == 'FieldInput') {
                                            if (Array.isArray(element.fieldTypes) && element.fieldTypes.length == 1) {
                                                type = element.fieldTypes[0]
                                            }
                                        }


                                        if (type) {
                                            type = TypeToInputType[type] ?? (element.dataType ?? element.type)
                                        }
                                        if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput') {
                                            isObject = true
                                        }

                                        console.log(type)

                                        return (

                                            <button key={key} className="flexcb p-1 px-2 mb-1 grayscale-filter  w-100 text-start" onClick={() => isObject ? this.setSourceAsObject(element) : this.sourceSelectHandler(element, key, this.props.prop?.id, true)}>
                                                <div className="flexc">
                                                    <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                        <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" alt="" />
                                                    </div>
                                                    <p className="font-size-13 text-semibold">{checkTranslation(name)}</p>
                                                </div>
                                                {isObject && (
                                                    <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                                )}
                                            </button>
                                        )
                                    })}
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 px-2 py-2">
                                <div className="bb-gray w-100 flexc mb-2">
                                    <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                        <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} alt="" />
                                    </button>
                                    {this.props.params && (
                                        <p className="text-smaller main-c2">{(this.props.params[this.state.source])?.label?.length > 20 ? (this.props.params[this.state.source])?.label?.substring(0, 20) + '...' : (this.props.params[this.state.source])?.label}</p>
                                    )}
                                </div>
                                <p className="text-smaller">{translate("Not found")}</p>
                            </div>
                        )}
                    </div> */}



                    {/* <div stage={1} stageName='object' className="mt-2" style={{ minHeight: '100px' }}>
                        {this.state.tempCurrentSourceObject && this.state.tempCurrentSourceObject?.structure?.length != 0 && (
                            <div className="scroll-no-scrollbar" style={{ maxHeight: '200px' }}>
                                <div className="bb-gray w-100 px-2 py-2 flexc " style={{ position: 'sticky', top: 0, zIndex: 1, background: '#fff' }}>
                                    <button className="flexcc" onClick={() => { this.goToPreviousStage() }}>
                                        <img src="/assets/icons/imports/arrowLeft.svg" className="mrd-1" style={{ width: '16px' }} />
                                    </button>
                                    <p className="text-small text-semibold">{(checkTranslation(this.state.tempCurrentSourceObject?.name))}</p>
                                </div>

                                <div className="pt-1">

                                    {(this.state.tempCurrentSourceObject?.structure == null || this.state.tempCurrentSourceObject?.structure?.length == 0) && (
                                        <div className="flexcc py-2">
                                            <p className="text-smaller text-semibold">{translate("Found nothing")}</p>
                                        </div>
                                    )}

                                    {this.state.tempCurrentSourceObject?.structure?.map((element) => {
                                        let name = element.name ?? element?.information?.label
                                        let key = element._id ?? element.key
                                        key = this.state.tempCurrentSourceObject?.key + '.' + key
                                        let type = (element.dataType ?? element.type)?.toLowerCase()
                                        let isObject = false
                                        if (type) {
                                            type = TypeToInputType[type] ?? (element.dataType ?? element.type)
                                        }
                                        if (type == 'object' || type == 'ObjectInput' || type == 'record' || type == 'RecordInput') {
                                            isObject = true
                                        }

                                        return (

                                            <button key={key} className="flexcb p-1 px-2 mb-1 grayscale-filter  w-100" onClick={() => isObject ? this.setSourceAsObject(element) : this.sourceSelectHandler(element, key, this.props.prop?.id, true)}>
                                                <div className="flexc">
                                                    <div className="br-4 flexcc mrd-2" style={{ background: "#f2f2f2", height: 24, width: 24 }}>
                                                        <img className="mx-1" style={{ opacity: 0.8 }} src={FormBuilderObjects[type]?.icon} width="18px" />
                                                    </div>
                                                    <p className="text-small text-semibold">{checkTranslation(name)}</p>
                                                </div>
                                                {isObject && (
                                                    <img className="mld-2" style={{ opacity: 0.8 }} src={'/assets/icons/useful/angle-right.svg'} width="16px" alt="" />
                                                )}
                                            </button>
                                        )
                                    })}

                                </div>
                            </div>
                        )}
                    </div> */}
                </StagesManager >

            </div >

        )
    }
}
// export default ParamsListItems;

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ParamsListItems);